/* eslint-disable react/react-in-jsx-scope */
import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import "./homepage-new.scss";

export default function SixthSectionHome() {
  return (
    <Box
      sx={{
        bgcolor: "#93B3B699",
        height: { xs: "auto", md: "30.375rem" },
        py: { xs: "2rem", md: "0rem" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Container maxWidth="lg">
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: { xs: "24px", sm: "28px", md: "34px" },
            lineHeight: "40px",
            color: "#104145",
          }}
        >
          Peace of Mind
          {/* <Box
            component="span"
            sx={{
              fontWeight: 300,
              fontSize: { xs: "24px", sm: "28px", md: "34px" },
              lineHeight: "40px",
              color: "#104145",
            }}
          >
            Reset
          </Box> */}
        </Typography>

        <Typography
          sx={{
            fontWeight: 400,
            fontSize: { xs: "28px", sm: "40px", md: "64px" },
            lineHeight: "110%",
            color: "#104145",
            mt: "1.5rem",
            mb: "1.5rem",
          }}
        >
          Support,&nbsp;
          <span style={{ color: "#9F7F2C" }}>When It Matters Most</span>
        </Typography>

        <Typography
          sx={{
            fontWeight: 400,
            fontSize: { xs: "16px", sm: "20px", md: "24px" },
            lineHeight: "150%",
            color: "#104145",
            mb: "1.5rem",
          }}
        >
          Planning ahead deserves clarity and direction.{" "}
          <Box component="span" fontWeight="bold">
            MemorialGo
          </Box>{" "}
          helps you prepare thoughtfully, so decisions feel organized and
          considered.
        </Typography>

        {/* <Typography
          sx={{
            fontWeight: 400,
            fontSize: { xs: "16px", sm: "20px", md: "24px" },
            lineHeight: "150%",
            color: "#104145",
            mb: "2rem",
          }}
        >
          Let us help ease the process.
        </Typography> */}

        {/* Hiding button for now */}
        <Box textAlign="center">
          <Button
            className="custom-btn"
            variant="contained"
            sx={{
              backgroundColor: "#EBD28D",
            }}
            style={{ display: "none" }}
          >
            Write a Review
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
